import { usePackageFlightReturnPageContainer } from "./usePackageFlightReturnPageContainer";

export const usePackageFlightReturnPage = () => {
  return usePackageFlightReturnPageContainer();
};
